import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ApiUrlHelper } from '../api-url-helper';
import { SliderTransformer } from '../../_transformers/slider.transformer';
import { HttpClientHelper } from '../http-helper';
import { map } from 'rxjs/operators';
import { InjectHttpClient } from '../InjectHttpClient';

@Injectable()
export class DnFocusesService {
    private sliders = {};
    private loadings = [];
    //private _slidersService = new BehaviorSubject<any>({});
    //slidersSource$ = this._slidersService.asObservable();

    constructor(
        // private _apiUrlHelper: ApiUrlHelper,
        // private _httpClientHelper: HttpClientHelper,
        private _injectClient:InjectHttpClient
    ) {

    }

    getDnFocuses(cid, region) {
        // region = region || "GL.";
        //  = cid ? cid : '0,1';
        // const apiURL = this._apiUrlHelper.urlBuilder('slide-list',
        //     {
        //         cid: categoryId,
        //         region: region,
        //         size:8
        //     });
        
        return this._injectClient.get("slide-list",{
            region:region || "GL.",
            cid:cid ? cid : '0,1',
            size:8
        },true);
        
    }
}
